namespace SorAraBul.Definitions {
    export class CurrenciesColumns {
        static columnsKey = 'Definitions.Currencies';
    }
}
